import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    success: false,
    user: {},
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.success = true;
      state.user = action.payload;
    },
    loginFailed: (state) => {
      state.success = false;
      state.user = {};
    },
    logout: (state) => {
      state.success = false;
      state.user = {};
    },
  },
});
export const { loginSuccess, loginFailed, logout } = authSlice.actions;
export default authSlice.reducer;
